import { Injectable, Injector, ErrorHandler } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/** Passes HttpErrorResponse to application-wide error handler */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}
  req2:HttpRequest<any>
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    
    // if(request.url.includes('axisbank.co.in'))
    // {
    //   this.req2 = request.clone({
    //     setHeaders: { 
    //         'Access-Control-Allow-Origin': '*', 
    //         'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT'
    //     }  
    //   })
    //   return next.handle(this.req2)
    // }
    // else{
    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            const appErrorHandler = this.injector.get(ErrorHandler);
            appErrorHandler.handleError(err);
          }
        }
      })
    );
    //  }
  }
}
